import React from 'react';
import { Paper, Typography, IconButton, CircularProgress, Box } from '@mui/material';
import {
  Description as DescriptionIcon,
  Clear as ClearIcon,
  DraftsOutlined,
  InsertDriveFileOutlined,
} from '@mui/icons-material';

const FileUploaded = ({ classes, name, uploaded, remove }) => {
  return (
    <Box
      sx={{
        my: '4px'
      }}
    >
      <Paper
        sx={{
          display: 'flex',
          width: '100%',
          height: 32,
          position: 'relative',
          cursor: 'pointer',
          '&:hover': {
            color: (theme) => theme.palette.primary.main,
          },
          transition: 'all 0.3s ease-in-out',
          border: (theme) => `1px solid ${theme.palette.common.outline}`,
          borderRadius: '8px',
          padding: '0px 16px',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
        elevation={0}
      >
        <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
          {uploaded ? (
            <InsertDriveFileOutlined sx={{ fontSize: '16px' }} color="primary" />
          ) : (
            <CircularProgress sx={{ fontSize: '16px' }} size={20} color="primary" />
          )}
          <Typography variant="body1" color="text.lightish" title={name} sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '135px',
            width: '100%',
            wordBreak: 'break-all',
          }}>
            {name}
          </Typography>
        </Box>
        {remove && (
          <IconButton
            aria-label="delete"
            sx={{
              width: '24px',
              height: '24px',
            }}
            onClick={remove}
          >
            <ClearIcon sx={{ fontSize: '16px' }} />
          </IconButton>
        )}
      </Paper>
    </Box>
  );
};
export default FileUploaded;
